import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { APIService } from '../../api.service';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-bom-print',
  templateUrl: './bom-print.component.html',
  styleUrls: ['./bom-print.component.scss']
})
export class BomPrintComponent implements OnInit {
  productID: number = 0;

  constructor(private commonFunService: CommonService, private apiService: APIService) { }
   
  prductData: any = {
    productID: 0,
    productName: '',
    bom:[]
  }
  products: any = [];
  jarvisData: any = [];
  agencyData:any = [];
  itemListData: any = [];
  totalCost: number = 0;
  prtCnfg: { rates: boolean, totalPrice: boolean} = {
    rates: false,
    totalPrice: false
  }
  right: any = [];
  isRateView: boolean = false;

  ngOnInit(): void {
    debugger
    let prodID = this.commonFunService.GetParam("ProductID");
    this.prductData.productID = Number(this.commonFunService.encryptData(prodID));
    
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    let jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
          this.jarvisData = JSON.parse(jarvis);
          this.getProductDetail();
    };
    this.right = this.apiService.getCookie("J");
    if(this.right){
      this.right = JSON.parse(this.right);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.right = $.grep(this.right, function(o: any){ return o.UserID == ownUserID })[0];
      console.log(this.right)
      if(!this.right.InvMstrs && !this.right.InvCfg && !this.right.InvRpts && !this.right.InvXns){
       window.location.href = "../../main.html#/home";
        return;
      }
      if(this.right.InvRateView.toString()  != "undefined"){
        this.isRateView = this.right.InvRateView;
     }
    }

    this.apiService.getIDB('erp_inv', (itemList: any) => {
      if (itemList && itemList.length > 0) {
        this.itemListData = itemList;
      }
    }); 
  }

  printBOMData() {
    setTimeout(function () {
        var printArea = $('#BOMDataPrint').html();
        $('body').html(printArea);
        window.print();
    });
  }

   //getProductDetail() - Get Product Details
   getProductDetail(){
    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT")
    let data = [{
      productID: this.prductData.productID
    }]

    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: MyLastSyncDT,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'get',
        moduleID: 4,
        data: JSON.stringify(data)
    }];

    return this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));  
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //successResp - success  get handler
  async successResp(res: any) {
    if (res.error) {
    }
    else {
        if (res) {
          var reponseData = JSON.parse(res.updatePackage);
          if(reponseData.Table[0].ErrCode == 1){
            this.apiService.successAlert(reponseData.Table[0].ErrMsg);
          }
          else{
            let productData = reponseData.Table[0];
            let BOMPrtCfg = reponseData.Table1[0];
            BOMPrtCfg = JSON.parse(BOMPrtCfg.BOMPrtCfg);
            if(BOMPrtCfg && BOMPrtCfg.length > 0){
              this.prtCnfg.totalPrice = BOMPrtCfg[0].totalPrice ? BOMPrtCfg[0].totalPrice : false;
              this.prtCnfg.rates = BOMPrtCfg[0].rates ? BOMPrtCfg[0].rates : false
            }
            this.prductData.productName = productData.ItemName;
            this.prductData.productCode = productData.ItemCode;
            this.prductData.bom = JSON.parse(productData.BOM);
            let itemList = this.itemListData
            
            this.prductData.bom.forEach(function (e: any) {
              let selectedItem = itemList.filter((x: any) => x.ItemID == e.IID);
              if(selectedItem.length > 0){
                e.ItemName = selectedItem[0].ItemName;
                e.ItemCode = selectedItem[0].ItemCode;
              }
            });
            for (let i = 0; i < this.prductData.bom.length; i++) {
              let tmpPRD = this.itemListData.filter((x: any) => x.ItemID == this.prductData.bom[i].IID);
              let reqQty: any = tmpPRD.length > 0 ? Number(this.prductData.bom[i].Qty).toFixed(tmpPRD[0].SKUPrecision) : Number(this.prductData.bom[i].Qty);
              if(tmpPRD.length > 0){
                this.prductData.bom[i].DefPurchRate = tmpPRD[0].DefPurchRate;
                this.totalCost = Number(this.totalCost) + (Number(tmpPRD[0].DefPurchRate) * reqQty);
              }
            }

            this.prductData.bom = this.prductData.bom.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName))
          }
          console.log(reponseData);
          this.printBOMData();  
        }
    }
  }
}
